import React from "react";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background: #f8f9fa;
  border-top: 1px solid rgba(0, 191, 255, 0.1);
  padding: 1.5rem 0;
  text-align: center;
  margin-top: auto;

  @media (max-width: 768px) {
    padding: 1.2rem 0;
  }

  @media (max-width: 480px) {
    padding: 1rem 0;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }

  @media (max-width: 480px) {
    padding: 0 12px;
  }
`;

const FooterText = styled.p`
  color: #5a6c7d;
  font-size: 0.9rem;
  margin: 0;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }

  @media (max-width: 480px) {
    font-size: 0.8rem;
    line-height: 1.4;
  }
`;

const FooterLink = styled.a`
  color: #00bfff;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    color: #0066cc;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #00bfff;
    outline-offset: 2px;
    border-radius: 2px;
  }

  @media (max-width: 480px) {
    font-weight: 500;
  }
`;

const Footer = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterText>
          This Website is Designed and Developed by{" "}
          <FooterLink
            href="https://triratnahitech.com/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Visit TriratnaHi-Tech website"
          >
            TriratnaHi-Tech
          </FooterLink>
        </FooterText>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;